module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.47ab7d6b.svg";